import { getApiUrl } from '@/api/apiClient';

export default {
  getAuthenticated: () => getApiUrl('/api/authenticated'),
  getHeartbeatAuthorized: () => getApiUrl('/api/heartbeat/authorized'),
};
